import React from 'react';
import {
  Box,
  Typography,
  useTheme,
  Fade
} from '@mui/material';
import { Shield } from 'iconsax-react';

interface SessionProtectionIndicatorProps {
  show: boolean;
  sessionType: 'CALL' | 'CHAT' | string;
  sessionData?: {
    fromName?: string;
    key?: string;
  };
}

const SessionProtectionIndicator: React.FC<SessionProtectionIndicatorProps> = ({
  show,
  sessionType,
  sessionData
}) => {
  const theme = useTheme();
//   const isVideoCall = sessionType !== 'CHAT';
//   const sessionIcon = isVideoCall ? Call : MessageText;

  return (
    <Fade in={show}>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1400,
          backgroundColor: theme.palette.warning.main,
          color: 'white',
          padding: '8px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1.5,
          maxHeight: '18px',
          boxShadow: theme.shadows[2]
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 20,
            height: 20,
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.2)'
          }}
        >
          <Shield size={12} color="white" />
        </Box>
        
        <Typography variant="body2" fontWeight={500} color="inherit">
          Session Protected
        </Typography>
      </Box>
    </Fade>
  );
};

export default SessionProtectionIndicator;
